function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0429688,0,0,0.0429688,14.3555,14.3555)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-241,-241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.406,0L138.594,0C62.172,0 0,62.172 0,138.594L0,373.41C0,449.828 62.172,512 138.594,512L373.41,512C449.828,512 512,449.828 512,373.41L512,138.594C512,62.172 449.828,0 373.406,0ZM481.984,373.41C481.984,433.277 433.277,481.984 373.406,481.984L138.594,481.984C78.723,481.984 30.016,433.277 30.016,373.41L30.016,138.594C30.016,78.723 78.723,30.016 138.594,30.016L373.41,30.016C433.277,30.016 481.984,78.723 481.984,138.594L481.984,373.41Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-241,-241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,116.004C178.805,116.004 116.004,178.805 116.004,256C116.004,333.195 178.805,395.996 256,395.996C333.195,395.996 395.996,333.195 395.996,256C395.996,178.805 333.195,116.004 256,116.004ZM256,365.98C195.359,365.98 146.02,316.645 146.02,256C146.02,195.359 195.359,146.02 256,146.02C316.645,146.02 365.98,195.359 365.98,256C365.98,316.645 316.645,365.98 256,365.98Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-241,-241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.344,66.285C376.531,66.285 357.977,84.844 357.977,107.652C357.977,130.465 376.531,149.023 399.344,149.023C422.156,149.023 440.715,130.465 440.715,107.652C440.715,84.84 422.156,66.285 399.344,66.285ZM399.344,119.004C393.086,119.004 387.992,113.91 387.992,107.652C387.992,101.391 393.086,96.301 399.344,96.301C405.605,96.301 410.699,101.391 410.699,107.652C410.699,113.91 405.605,119.004 399.344,119.004Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.77f8aa5cc9599e05e2a940a798f605d6.svg";
export { ForwardRef as ReactComponent };